@if (images.length > 0) {
  <div class="collection-cover-grid">
    @for (imageContainer of imageContainers; track imageContainer; let index = $index) {
      <div [ngClass]="[imageContainer]">
        <img [defaultImage]="defaultImage" [lazyLoad]="hasImage(index) ? images[index].thumb : defaultImage" />
      </div>
    }
  </div>
}
